import FetchError from '@atlassian/jira-fetch/src/utils/errors.tsx';
import { getDefaultOptions } from '@atlassian/jira-fetch/src/utils/fetch-default-options-with-strict-mode.tsx';
import type { AccountId } from '@atlassian/jira-shared-types/src/general.tsx';
import { getReroutableURL } from '@atlassian/jira-fetch/src/utils/get-reroutable-url.tsx';
import { fg } from '@atlassian/jira-feature-gating';

export const getUserPropertiesUrl = (accountId: AccountId, propertyKey: string): string =>
	`/rest/api/latest/user/properties/${propertyKey}?accountId=${encodeURIComponent(accountId)}`;
const getUserPropertiesUrlWithReroute = (accountId: AccountId, propertyKey: string): string => {
	const path = getUserPropertiesUrl(accountId, propertyKey);
	return fg('magma-3429_banners_in_modern_ssr') ? getReroutableURL(path) : path;
};

export const setUserProperties = async (
	accountId: AccountId,
	propertyKey: string,
	data: string, // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<any> => {
	const url = getUserPropertiesUrlWithReroute(accountId, propertyKey);
	return fetch(url, {
		...getDefaultOptions(url),
		method: 'PUT',
		body: data,
	});
};

export const getUserProperty = <T,>(accountId: AccountId, propertyKey: string): Promise<T> => {
	const url = getUserPropertiesUrlWithReroute(accountId, propertyKey);
	return fetch(url, getDefaultOptions(url))
		.then((res) => {
			if (res.status === 200) {
				return res.json();
			}

			return res.text().then((errResp) => {
				throw new FetchError(res.status, errResp);
			});
		})
		.then((data) => data.value);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteUserProperty = (accountId: AccountId, propertyKey: string): Promise<any> => {
	const url = getUserPropertiesUrlWithReroute(accountId, propertyKey);
	return fetch(url, {
		...getDefaultOptions(url),
		method: 'DELETE',
	});
};
